<div class="qr-scanner-container"
  [ngStyle]="{'background-color': hasPermission === true ? 'transparent' : 'var(--general-body-primary)' }">

  <zxing-scanner [(device)]="currentDevice" (scanSuccess)="onScanResultClick($event)" [formats]="formatsEnabled"
    (permissionResponse)="onHasPermission($event)" (camerasFound)="onCamerasFound($event)"></zxing-scanner>

  <div class="scanner-container">
    <div class="scanner-header">
      <i class="icon-chevron-left" (click)="closeScannerDialog()"
        [ngClass]="{'backBtn-withoutPermission': !hasPermission }"></i>
    </div>

    <div class="scanner-content">
      <div class="dineIn-msg"
        *ngIf="selectedChannel?.orderType === orderTypeFlag.DineIn && tableNoReq && showHeaderDesc"
        [hidden]="hasPermission === false">{{'scan.to.get.location' | translate}}</div>

      <div class="no-permission-msg" *ngIf="hasPermission === false">
        <img src="assets/generalImage/camera_permission.svg" alt="mascot" />
        <h1>{{'desc.camera.permission.denied' | translate}}</h1>
      </div>
    </div>
  </div>
</div>